// extracted by mini-css-extract-plugin
export default {"skillstag":"jobsStyle_skillstag__sjk+g"};